/*
* English texts
*/
export default {
  // v3
  'waiting': 'Waiting',
  'checking': 'Checking',
  'processing': 'Processing',
  'delivered': 'Delivered',
  'archived': 'Archived',
  'rejected': 'Rejected',
  'active': 'Active',
  'Total Group': 'Total Groups',
  'golive': 'Go live',
  'Billing': 'Billing',
  'Try-on': 'Try-on',
  'Top 10 try-on products': 'Top 10 try-on products',
  'Try-on count': 'No. of tries',
  'Try-on time (minutes)': 'Tries in minutes',
  'Status': 'Status',
  'From': 'From',
  'To': 'To',
  'Sort by': 'Sort by',
  'time(s)': ' time(s)',
  'Overview': 'Overview',
  'Last 24 hours': 'Last 24 hours',
  'Last 7 days': 'Last 7 days',
  'Last 30 days': 'Last 30 days',
  'This year': 'This year',
  'All time': 'All time',
  'Amount until now': 'Amount until now',
  'Web': 'Web',
  'Mobile': 'Mobile',
  'fWeb': 'Web',
  'fMobile': 'Mobile',
  'Total SKU': 'Total SKUs',
  'Add product': 'Add product',
  'Latest': 'Latest',
  'Oldest': 'Oldest',
  'Try-on count: ascending': 'Number of tries: ascending',
  'Try-on count: descending': 'Number of tries: descending',
  'Created date': 'Created date',
  'Pay all': 'Pay all',
  'Date': 'Date',
  'Invoice': 'Invoice',
  'Amount': 'Amount',
  'On going': 'ON GOING',
  'Paid': 'PAID',
  'Unpaid': 'UNPAID',
  'Drop files here': 'Drop files here',
  'or': 'or',
  'Browse files': 'Browse files',
  'All files must be in ".zip" type and follow by below instruction link': 'All files must be in ".zip" or ".glb" type and follow by below instruction link.',
  'Yes, we support upload multiple files at once': 'Yes, we support upload multiple files at once.',
  'How to capture glasses assets': 'How to capture glasses assets',
  'Please provide SKU code': 'Please provide SKU code',
  'Are you sure to request creating glasses?': 'Are you sure to request creating glasses?',
  'Files': 'Files',
  'Unit price': 'Unit price',
  'Trial': 'Trial',
  'Product count': 'Product count',
  'Notifications': 'Notifications',
  'Download latest assets': 'Download latest assets',
  'Upload new assets': 'Upload new assets',
  'Upload new assets successfully': 'Upload new assets successfully',
  'Billing Report': 'Billing Report',
  'Details': 'Details',
  'Live try-on usage': 'Live try-on usage',
  'Data not found': 'No product found',
  'You have no billings': 'You currently have no billing history',
  'digital assets have been delivered': '{sku} digital assets have been delivered.',
  'free 25 SKUs': 'free 25 SKUs',
  'Payment': 'Payment',
  'Copy': 'Copy',
  'CopiedURLParams': 'Copied URL parameters to clipboard',

  // Filter text translate
  'all': 'All',

  // Sign up Text Translate
  'SIGN_UP_STEP_1' : 'Sign up',
  'SIGN_UP_STEP_2' : 'Verify account',
  'SIGN_UP_STEP_3' : 'Complete profile',
  'TERM_AND_PRIVACY_TEXT_1' : 'By clicking on sign up, you agree to our ',
  'TERM_AND_PRIVACY_TEXT_2': 'terms',
  'TERM_AND_PRIVACY_TEXT_3': ' and ',
  'TERM_AND_PRIVACY_TEXT_4': 'privacy policy',
  'TERM_AND_PRIVACY_TEXT_5': '.',
  'PASSWORD_STRENGTH_0' : 'Strength',
  'PASSWORD_STRENGTH_1' : 'Very Weak',
  'PASSWORD_STRENGTH_2' : 'Weak',
  'PASSWORD_STRENGTH_3' : 'Normal',
  'PASSWORD_STRENGTH_4' : 'Strong',
  'PASSWORD_STRENGTH_5' : 'Very Strong',

  'ACCOUNT_VERIFICATION' : 'Account Verification',
  'CHECK_MAIL_TEXT_1' : 'Please check your email',
  'CHECK_MAIL_TEXT_2' : 'and follow the verification link.',
  'RESEND_EMAIL_TEXT' : 'Resend verification email',

  'COMPLETE_PROFILE_1' : 'At final step, please complete your',
  'COMPLETE_PROFILE_2' : 'to continue operation.',


  // Upgrade plan Text Translate
  'PLAN_GLASSON_HEADER': 'GlassOn',
  'PLAN_GLASSON_TITLE_LINE_1': 'Join new glasses selling approach with 3D virtual glasses tryon',
  'PLAN_GLASSON_TITLE_LINE_2_P1': 'Try PRO membership',
  'PLAN_GLASSON_TITLE_LINE_2_P2': 'risk-free for 30 days',
  'PLAN_FREE_TITLE': 'FREE',
  'PLAN_PRO_TITLE': 'PRO',
  'PLAN_PRO_FROM': 'From',
  'PLAN_PERMONTH_TEXT': 'per month',
  'PLAN_PRO_CHECK_OUT_DESCRIPTION': '1st month free for trial (charge from 2nd month)',
  'PLAN_FREE_JOIN_NOW_BTN': 'Join now',
  'PLAN_PRO_UPGRADE_NOW_BTN': 'Upgrade now',
  'PLAN_FREE_DESCRIPTION': 'For taste of GlassOn service',
  'PLAN_FREE_VIRTUAL_DESCRIPTION' : ' ',
  'PLAN_PRO_DESCRIPTION': 'For Shops, Brands and Manufactures',
  'PLAN_SUBCRIPTION_LINE_1_FREE': 'Register up to 5 Products.',
  'REGISTER_UP': 'Register up to ',
  'PLAN_SUBCRIPTION_LINE_1_VIRTUAL_TEXT': ' Charge according to number of Product, purchase with 100 Product unit (refer to Detail Price Plan)',
  'PLAN_SUBCRIPTION_LINE_1_PRO': ' Products. Charge according to number of Product, purchase with 100 Product unit ',
  'PLAN_SUBCRIPTION_LINE_1_PRO_REFER_TO': 'refer to ',
  'PLAN_SUBCRIPTION_LINE_1_PRO_PRICE_DETAIL': 'Detail Price Plan',
  'PLAN_SUBCRIPTION_LINE_2': 'Virtual tryon your own registered Product by GlassOn application',
  'PLAN_SUBCRIPTION_LINE_3_P1': 'Generate Embedded Web-link for tryon',
  'PLAN_SUBCRIPTION_LINE_3_P2': '(For lead to GlassOn application)',
  'PLAN_SUBCRIPTION_LINE_4_P1': 'Generate QR Code for tryon',
  'PLAN_SUBCRIPTION_LINE_4_P2': '(For lead to GlassOn application)',
  'PLAN_SUBCRIPTION_LINE_5': 'Support 2D Glasses Data',
  'PLAN_SUBCRIPTION_LINE_6': 'Publish your own registered Product to Store list on GlassOn application',
  'PLAN_FREE_FOOTER_TITLE': 'Upgrade anytime',
  'PLAN_PRO_FOOTER_TITLE': 'Boost your sales by GlassOn!',
  'PLAN_FREE_TEXT': 'Free',
  'SELECTED_PLAN': 'Current Plan',
  'SUPPORT_TEXT': 'Support making 2D Glasses Data to register GlassOn as an option service with extra charge ',
  'CONTACT_US_TEXT_1': '(',
  'CONTACT_US_TEXT_2': 'contact to us',
  'CONTACT_US_TEXT_3': ' for more detail of service)',
  'PLAN_DOWNGRADE_BTN': 'Downgrade',
  'BOOST_YOUR_BUSINESS': 'Boost your sales by GlassOn!',

  // Check out Text Translate
  'CHECK_OUT_UPDATE_PLAN': 'Update plan',
  'CHECK_OUT_PRODUCT_PACK': 'Product Pack',
  'CHECK_OUT_UPDATE_PLAN_COL_1': 'New plan',
  'CHECK_OUT_UPDATE_PLAN_COL_2': 'Your bill estimation on next 30 days',
  'CHECK_OUT_UPDATE_PLAN_COL_3': 'Your monthly bill estimation after next 30 days',
  'CHECK_OUT_YOUR_MONTHLY_BILL': 'Your monthly bill',
  'CHECK_OUT_FREE_PLAN': 'Free',
  'CHECK_OUT_CURRENT_PLAN': 'Current plan',
  'CHECK_OUT_CURRENT_PLAN_COL_1': 'Your current plan',
  'CHECK_OUT_CURRENT_PLAN_COL_2': 'Your next build',
  'CHECK_OUT_PAYPAL_INFO': 'Paypal information',

  // Profile Text Translate
  'PROFILE_TITLE': 'Profile',
  'PROFILE_GENERAL_TAB': 'General',
  'PROFILE_CHANGE_PASS_TAB': 'Change password',
  'PROFILE_STORE_NAME': 'Store name',
  'PROFILE_NAME': 'Name',
  'PROFILE_DESCRIPTION': 'Description',
  'PROFILE_HOMEPAGE': 'Home page',
  'PROFILE_WEBSITE': 'Website',
  'PROFILE_ADDRESS': 'Address',
  'PROFILE_ADDRESS_LINE_1': 'Address line 1',
  'PROFILE_ADDRESS_LINE_2': 'Address line 2',
  'PROFILE_CONTACT_EMAIL': 'Contact email',
  'PROFILE_PHONE': 'Phone',

  // Price Detail Text Translate
  'PRICE_DETAIL_TITLE': 'Price Detail',
  'PRICE_DETAIL_PRO_PLAN_TITLE': 'Pro plan: Each 100 unit price',
  'PRICE_DETAIL_PRO_PLAN_CURRENCY': 'Currency',
  'PRICE_DETAIL_PRO_PLAN_DESCRIPTION': '* 100 product unit purchase only',
  'PRICE_DETAIL_PRO_PLAN_COL_1': 'Number of registration Product',
  'PRICE_DETAIL_PRO_PLAN_COL_2': 'Each 100 product unit price',
  'PRICE_DETAIL_PRO_PLAN_COL_3': '6 ~ 300 unit price',
  'PRICE_DETAIL_PRO_PLAN_COL_4': '301 unit upper price',
  'PRICE_DETAIL_PRO_PLAN_COL_5': 'Total',
  'PRICE_DETAIL_PRO_PLAN_EXAMPLE_TEXT': 'Ex: monthly price calculation base on number of Product registration',

  'PRICE_DETAIL_SUBCRIPTION_TEXT': 'Term of subscription',
  'PRICE_DETAIL_SUBCRIPTION_LINE_1': '1st time upgrade to PRO pack, you have 30 days free of use for trial.',
  'PRICE_DETAIL_SUBCRIPTION_LINE_2': 'Payment timing point is each 30 days duration from registration date or after trial period end.',
  'PRICE_DETAIL_SUBCRIPTION_LINE_3': 'You can change from PRO pack to Free pack any time, beware to below importance note.',
  'PRICE_DETAIL_SUBCRIPTION_LINE_4': 'Note:',
  'PRICE_DETAIL_SUBCRIPTION_NOTE_1': 'You are required to ',
  'PRICE_DETAIL_SUBCRIPTION_NOTE_1_IMP': 'pay fee for usage so far right at the time of changing plan',
  'PRICE_DETAIL_SUBCRIPTION_NOTE_2': 'All registered Products are changed to "Wait for remove" in 5 days before permanent remove out of system',
  'PRICE_DETAIL_SUBCRIPTION_NOTE_3': 'In case User change back from Free pack to PRO pack, then existing "Wait for remove" Products  in limit of new Plan are changed to normal Active state',
  'PRICE_DETAIL_SUBCRIPTION_EXAMPLE_TEXT': 'Ex: Begin register 100 products on January 5th. After that upgrade to 400 products on next February 20th. After that downgrade to 300 products on next May 15th.',
  'PRICE_DETAIL_SUBCRIPTION_EXAMPLE_COL_1': 'Explain',
  'PRICE_DETAIL_SUBCRIPTION_EXAMPLE_COL_2': 'Timing Point',
  'PRICE_DETAIL_SUBCRIPTION_EXAMPLE_COL_3': 'Payment Amount',
  'PRICE_DETAIL_SUBCRIPTION_EXAMPLE_COL_4': 'Note',

  'SUBCRIPTION_EX': 'Ex: you register follow assumption below',
  'SUBCRIPTION_EX_LINE_1': 'First register 300 Products PRO pack on January 5th, and use full 300 Products',
  'SUBCRIPTION_EX_LINE_2': 'Change from PRO pack to Free pack on March 20th.',
  'SUBCRIPTION_EX_LINE_3': 'Then register 100 Products PRO pack on March 24th.',

  'EXPLAIN_LINE_1': 'Change Free to PRO-300',
  'EXPLAIN_LINE_2': '1st PRO-300 payment',
  'EXPLAIN_LINE_3': '2nd PRO-300 payment',
  'EXPLAIN_LINE_4': 'Change PRO to Free',
  'EXPLAIN_LINE_5': 'Change Free to PRO-100',
  'EXPLAIN_LINE_6': '1st PRO-100 payment',
  'EXPLAIN_LINE_7': '2nd PRO-100 payment',
  'EXPLAIN_LINE_8': '3rd PRO-100 payment',
  'NOTE_LINE_1': 'Free Trial Program',
  'NOTE_LINE_2': '1 month usage fee for PRO-300 pack',
  'NOTE_LINE_3': 'Usage fee from 6-Mar to 20-Mar',
  'NOTE_LINE_4': '1 month usage fee for PRO-100 pack',
  'SUB_NOTE_LINE_1': '*300 Products change to "Wait for remove" state',
  'SUB_NOTE_LINE_2': '*Latest 100 Products change to "Active" state, the rest 200 Products chang to "Wait for remove" state',
  'SUB_NOTE_LINE_3': '*200 "Wait to remove" Products are remove permanent',
  'PRODUCT_PRICE': 'Product price',
  'FREE_DURATION': 'Free duration',
  'UPPER': 'upper',
  // 'TO': 'to',

  'DASHBOARD': 'Dashboard',
  'ANALYTICS': 'Analytics',
  'PAYMENT_REPORT': 'Payment Report',
  'PRODUCT_LIST': 'Product List',
  'CONTACT_US': 'Contact Us',
  'UPLOAD_STEP_1': 'Input glasses general information',
  'UPLOAD_STEP_2': 'Input glasses model',
  'GENERAL_INFORMATION': 'General information',
  'SKU': 'Product name (SKU)',
  'kids': 'Kids',
  'other': 'Other',
  'GLASSES_TYPE': 'Glasses type',
  'eyeglasses': 'Eyeglasses',
  'sunglasses': 'Sunglasses',
  'sportglasses': 'Sportglasses',
  'FRAME_TYPE': 'Frame type',
  'full_frame': 'Full frame',
  'rimless': 'Rimless',
  'semi_rimless': 'Half frame',
  'FRAME_SHAPE': 'Frame shape',
  'rectangle': 'Rectangle',
  'square': 'Square',
  'wayframe': 'Wayframe',
  'oversized': 'Oversized',
  'oval': 'Oval',
  'wrap': 'Wrap',
  'aviator': 'Aviator',
  'cateye': 'Cat eye',
  'round': 'Round',
  'browline': 'Browline',
  'geometric': 'Geometric',
  'butterfly': 'Butterfly',
  'wellington': 'Wellington',
  'boston': 'Boston',
  'nose_pad': 'Nose pad',
  'resin': 'Resin',
  'celluloid': 'Celluloid',
  'titanium': 'Titanium',
  'stainless': 'Stainless',
  'PUBLIC_MODE_TITLE': 'Public to GlassOn store list',
  'LOCALE_INFORMATION': 'Locale information',
  'SELECT_LOCALE': 'Select locale',
  'LINK_TO_PRODUCT_WEBSITE': 'Link to product website',
  'URL': 'Product website',
  'NOTE': 'Description',
  'Next': 'Next',

  'Name': 'Name',
  'EmailAddress': 'Email address',
  'Subject': 'Subject',
  'Content': 'Content',
  'Send': 'Send',

  'Menu': 'Menu',
  'Dashboard': 'Dashboard',
  'Analytics': 'Analytics',
  'PaymentReport': 'Payment Report',
  'ProductList': 'Product List',
  'LensList': 'Lens List',
  'ContactUs': 'Contact Us',

  'Top10': 'Top 10 products downloaded',
  'NumberOfDownloads': 'Number of downloads',
  'NumberOfDownloads_1byte': 'Download count',
  'SaveQRcode': 'Save QR code',

  'StartContract': 'Start Contract',
  'EndContract': 'End Contract',
  'RegisteredProductPack': 'Registered Product Pack',
  'TotalAmount': 'Total Amount',

  'TermOfService': 'Term of Service',
  'PrivacyPolicy': 'Privacy Policy',
  'ServiceLevelAgreement': 'Service Level Agreement',

  'Modify': 'MODIFY',
  'ConsumedProducts': 'Consumed products',

  'DOWNGRADE_TITLE': 'Before downgrade your plan, remember that:',
  'DOWNGRADE_WAITING_FOR_REMOVE': 'Waiting for remove',
  'DOWNGRADE_LINE1_1': '1. GlassOn service will just keep latest 5 products as they are, and set the rest of products to "',
  'DOWNGRADE_LINE1_2': '" status.',
  'DOWNGRADE_LINE2_1': '2. "',
  'DOWNGRADE_LINE2_2': '" products are work like normal products, but they will be removed permanent out of system after 5 days from today.',
  'DOWNGRADE_LINE3': '3. Please select new PRO plan or have plan to back up your data within 5 days.',
  'DOWNGRADE_LINE4_1': '4. After select new PRO plan, within capability of new plan then all latest "',
  'DOWNGRADE_LINE4_2': '" products will automatically reset to normal status.',
  'DOWNGRADE_LINE5_1': '5. For more information, please refer to ',
  'DOWNGRADE_LINE5_2': '.',
  'DOWNGRADE_NOTE_1': 'Note that you have to pay ',
  'DOWNGRADE_NOTE_2': ' for usage so far.',
  'DOWNGRADE_NOTE_UNPAID': 'Note that you don’t have to pay for downgrade plan due during Trial period.',
  'DOWNGRADE_ASK': 'Please enter "Downgrade" on input field below',

  'URL_INVALID': 'URL is invalid',
  'PHONE_INVALID': 'Phone number is invalid',
  'ACCOUNT_VERIFIED_SUCCESS': 'Your account has been verified successfully.',

  'Prev': 'Prev',
  'WILL_BE_REMOVED_ON': 'Will be removed on ',
  'SAMPLE_DATA': 'sample data',

  'CHECKOUT_LINE1_1': 'Your new plan is [',
  'CHECKOUT_LINE1_2': '].',
  'CHECKOUT_LINE2_1': 'Your next payment is on ',
  'CHECKOUT_LINE2_2': ' with ',
  'CHECKOUT_LINE2_3': ' amount of money.',

  'PAYMENT_REPORT_CURRENT_PLAN': 'Current plan ',
  'PAYMENT_REPORT_CURRENT_PLAN_PRODUCT': ' ',
  'PAYMENT_REPORT_START_FROM': 'Start from ',
  'PAYMENT_REPORT_NEXT_PAYMENT_ON': 'Next payment on ',
  'PAYMENT_REPORT_AMOUNT': 'Amount',
  'PAYMENT_REPORT_TRIAL_PERIOD_STATUS': 'Trial period status ',
  'PAYMENT_REPORT_TRIAL_PERIOD_STATUS_DAY': ' days',
  'PAYMENT_REPORT_PRODUCT': ' products ',
  'PAYMENT_REPORT_MONTHLY_BILL': 'monthly bill: ',

  'LENS_WIDTH': 'Lens width',
  'LENS_HEIGHT': 'Lens height',

  'BRAND_NAME': 'Brand name',
  'Search': 'Search',
  'EXPORT_CSV': 'Export CSV ({{status}} SKUs)',
  'IMPORT_CSV': 'Import CSV',
  'EXPORT_ALL_DATA': 'Export CSV (all SKUs)',
  'IMPORT_FAILED_TITLE': 'Data format is wrong. Please check your data again.',
  'Import': 'Import',
  'IMPORT_CONFIRMATION_TITLE': 'Do you want to import these data?',
  'ARCHIVE_VOLUME_RESTRICTION_MSG': '(file size of archive should be lower than 5MB)',
  'ARCHIVE_VOLUME_RESTRICTION_MSG_2': '(each image resolution should be lower than 2000x2000)',

  'DESCRIPTION_LENGTH_RESTRICTION': 'The maximum number of characters allowed in this field is 4,096',
  'COMPANY_NAME': 'Company name',
  'SHOP_LOCALE': 'Shop Locale',
  'SHOP_LOCATION': 'Shop location',
  'SAMPLE_CODE': 'sample code',
  'BASIC_USAGE': 'Basic use',
  'BASIC_HOWTO': 'using <iframe> if you would like to use default try-on button. <iframe> also includes QR code.',
  'ADVANCED_USAGE': 'Advanced use',
  'ADVANCED_HOWTO': 'using <a href> if you would like to change try-on button. Please refer to sample code.',
  'LINKED_PRODUCT': 'Linked products:',
  'LINK_TO_PRODUCT_LOCALE': 'Click here to create more locales',
  'HOWTO_GLOBAL_MODE': 'Please tick if you\'d like to make this product visible on all locales',
  'GUIDELINE_LOCALE': 'Here you can make locale patterns to be used in "Locale information" of each products.',
  'DOWNLOAD_TEMPLATE': 'Download CSV template',
  'SIZE_SETTING_GUIDELINE': '* Each size value should be according to boxing system',
  'EDIT_TIPS': 'Hint: press ▲ ▼ ◀ ▶ ➖ ➕ keys to move or resize glasses parts',

  // Country code
  'JP': 'Japan',
  'SG': 'Singapore',
  'CN': 'China',
  'TW': 'Taiwan',
  'TH': 'Thailand',
  'KH': 'Cambodia',
  'PH': 'Philippines',
  'AU': 'Australia',
  'MY': 'Malaysia',
  'VN': 'Vietnam',
  'ID': 'Indonesia',
  'RU': 'Russia',
  'IN': 'India',
  'US': 'United States',
  'GB': 'United Kingdom',
  'DE': 'Germany',
  'IT': 'Italy',
  'FR': 'France',
  'ES': 'Spain',

  // Language code
  'Language': 'Language',
  'ja': 'Japanese',
  'en': 'English',
  'zh': 'Chinese',
  'th': 'Thai',
  'km': 'Khmer',
  'vi': 'Vietnamese',
  'id': 'Indonesian',
  'ru': 'Russian',
  'hi': 'Hindi',
  'de': 'German',
  'it': 'Italian',
  'fr': 'French',
  'es': 'Spanish',

  // Currency code
  'JPY': 'JPY - Yen',
  'SGD': 'SGD - Singapore Dollar',
  'CNY': 'CNY - Renminbi (Yuan)',
  'THB': 'THB - Thai Baht',
  'USD': 'USD - US Dollar',
  'PHP': 'PHP - Philippine Peso',
  'AUD': 'AUD - Australian Dollar',
  'MYR': 'MYR - Malaysian Ringgit',
  'VND': 'VND - Vietnamese Dong',
  'IDR': 'IDR - Rupiah',
  'RUR': 'RUR - Russian Ruble',
  'RUB': 'RUB - Russian Ruble',
  'INR': 'INR - Indian Rupee',
  'GBP': 'GBP - Pound Sterling',
  'EUR': 'EUR - Euro',

  // Lazy translated text
  'Email': 'Email',
  'ContactEmail': 'Contact Email',
  'Emailisinvalid': 'Email is invalid',
  'Password': 'Password',
  'Passwordisinvalid': 'Password is invalid',
  'LOGIN': 'LOGIN',
  'Login': 'Login',
  'Signup': 'Sign up',
  'Forgotyourpassword?': 'Forgot your password?',
  'Shopname': 'Shop name',
  'Confirmpassword': 'Confirm password',
  'Byclickingonsignupyouagreetoourtermsandprivacypolicy.': 'By clicking on sign up, you agree to our terms and privacy policy.',
  'NamemustNOTbeempty': 'Name must NOT be empty',
  'Confirmpasswordisnotmatchedwithpassword': 'Confirm password is not matched with password',
  'Notice': 'Notice',
  'Youraccounthasbeenregisteredsuccessfully.': 'Your account has been registered successfully.',
  'Pleasecheckyouremailtoverifythisaccount.': 'Please check your email to verify this account.',
  'Enteryouremailaddressthatyouusedtoregister.Wellsendyouanemailwithyourusernameandalinktoresetyourpassword.': 'Enter your email address that you used to register. We\'ll send you an email with your username and a link to reset your password.',
  'ConfirmEmail': 'Confirm Email',
  'Anemailhasbeensendto': 'An email has been send to ',
  '.Pleasecheckforanemailfromusandclickontheincludedlinktoresetyourpassword.': '. Please check for an email from us and click on the included link to reset your password.',
  'ResetPassword': 'Reset Password',
  'Yourpasswordhasbeenresetsuccessfully.': 'Your password has been reset successfully.',
  'Gender': 'Gender',
  'male': 'Male',
  'female': 'Female',
  'Birthday': 'Birthday',
  'Day': 'Day',
  'Month': 'Month',
  'Year': 'Year',
  'Introduction': 'Introduction',
  'Description': 'Description',
  'Website': 'Website',
  'Createddate': 'Created date',
  'Address': 'Address',
  'Phone': 'Phone',
  'Room': 'Room',
  'Floor': 'Floor',
  'Building': 'Building',
  'Save': 'Save',
  'Edit': 'Edit',
  'Cancel': 'Cancel',
  'Oldpassword': 'Old password',
  'Newpassword': 'New password',
  'Yourpasswordhasbeenupdated': 'Your password has been updated',
  'General': 'General',
  'ChangePassword': 'Change Password',
  'Yourprofilehasbeenupdated': 'Your profile has been updated',
  'Free': 'Free',
  'Gold': 'Gold',
  'Enterprise': 'Enterprise',
  'GetGold': 'Get Gold',
  'Contactus': 'Contact us',
  '¥9,980/monthlysubscription': '¥9,980/monthly subscription',
  'Only5glasses': 'Only 5 glasses',
  'Upto100glasses': 'Up to 100 glasses',
  'AllowtobuildonGlassOnsite': 'Allow to build on GlassOn site',
  'Publishglasses': 'Publish glasses',
  'AllowtopublishglassesproducttostorelistofGlassOnapplication': 'Allow to publish glasses product to store list of GlassOn application',
  'Highpriority': 'High priority',
  'Higherpriority': 'Higher priority',
  'PriorityofappearanceorderinstorelistofGlassOnapplication': 'Priority of appearance order in store list of GlassOn application',
  'Support': 'Support',
  'Supportbuildglassesproductfrom3Dmodel': 'Support build glasses product from 3D model',
  'SupportmakingdedicateapplicationlikeGlassOnapplication': 'Support making dedicate application like GlassOn application',
  'SupportmakingECwebsitewithfullARtryonfunction': 'Support making EC web site with full AR try-on function',
  'Registerfree': 'Register free',
  'Upgradeanytime': 'Upgrade anytime',
  'Makeacalltous': 'Make a call to us',
  'Entercode': 'Enter code',
  'Haveadiscount?': 'Have a discount?',
  'Add': 'Add',
  'Validdiscountcode': 'Valid discount code',
  'Invaliddiscountcode': 'Invalid discount code',
  'PAYPAL_GUIDE_1A': 'You need a ',
  'PAYPAL_GUIDE_1B': ' account for payment.',
  'PAYPAL_GUIDE_2': 'You can make a new PayPal account in the next step of "PLACE ORDER".',
  'AddressLine1': 'Address Line 1',
  'AddressLine2': 'Address Line 2',
  'City': 'City',
  'State': 'State',
  'ZIPCode': 'ZIP Code',
  'AddressLine1_Placeholder': 'StayBridge Suites',
  'AddressLine2_Placeholder': 'Crook Street',
  'City_Placeholder': 'San Jose',
  'State_Placeholder': 'CA',
  'ZIPCode_Placeholder': '95112',
  'Country': 'Country',
  'PlaceOrder': 'Place Order',
  'PaymentExecution': 'Payment Execution',
  'PaymentCancellation': 'Payment Cancellation',
  'Congratulations': 'Congratulations',
  'Waitingforcompletingyourtransaction...': 'Waiting for completing your transaction...',
  'Yourtransactionisinvalid.': 'Your transaction is invalid.',
  'Yourtransactionhasbeencompleted.': 'Your payment registration has been completed.',
  'YouarecurrentlyaGolduser.Pleasetryourbestservices.': 'You are currently a Gold user. Please try our best services.',
  'Yourtransactionhasbeencanceled.': 'Your transaction has been canceled.',
  'Gotohomepage': 'Go to home page',
  'Brand': 'Brand',
  'Material': 'Material',
  'Shape': 'Shape',
  'Size': 'Size',
  'Price': 'Price',
  'Tryon': 'Try on',
  'ShowQRcode': 'Show QR code',
  'Nodescriptions': 'No descriptions',
  'Embed': 'Embed',
  'Removethisglasses?': 'Remove these glasses?',
  'Removethismodel?': 'Remove this model?',
  'Thisshophasntpostedanyglassesyet!': 'This shop hasn\'t posted any glasses yet!',
  'OK': 'OK',
  'Delete': 'Delete',
  'Remove': 'Remove',
  'Upload': 'Upload',
  'GlassesList': 'Product List',
  'Addnewglasses': 'Add new glasses',
  'Updateall': 'Update all',
  'Youreachthelimitofglassesamount': 'You reach the limit of glasses amount',
  'Pleaseupgradeyouraccounttogetupto100builtableglasses.': 'Please upgrade your account to get up to 100 built-able glasses.',
  'Updatesuccessful': 'Update successful',
  'Thumbnail': 'Thumbnail',
  'Modelname': 'Model name',
  'Shortdescription': 'Short description',
  'Publicmode': 'Public mode',
  'Action': 'Actions',
  'Forembedpurposeaddthislinealongwithyourglasses': 'For embed purpose, add this line along with your glasses',
  'Eye': 'Eye',
  'Bridge': 'Bridge',
  'Temple': 'Temple',
  'Lenscolor': 'Lens color',
  'Glassessite': 'Glasses site',
  'Topublishthisglassesyouneedtoupgradeyouraccount.': 'To publish this glasses, you need to upgrade your account.',
  'Upgrade': 'UPGRADE',
  'Editglasses': 'Edit glasses',
  'Tellusyourglassesname': 'Tell us your glasses name',
  'Thisfieldcannotbeblank': 'This field cannot be blank',
  'unisex': 'Unisex',
  'metal': 'Metal',
  'plastic': 'Plastic',
  'metal_plastic': 'Metal & plastic',
  'Linktostorewebsite': 'Link to store website',
  'Resettoclearcolor': 'Reset to clear color',
  'Glassesparts': 'Glasses parts',
  'Editglassesparts': 'Edit glasses parts',
  'Youmissedfilesinarchive': 'You missed file(s) in archive',
  'Requiredanarchiveincludingthesefiles': 'Required an archive including these files',
  'Reset': 'Reset',
  'Detail': 'Detail',
  'Profile': 'Profile',
  'Logout': 'Logout',
  'Yourglasseshasbeenupdated': 'Your glasses has been updated',
  'Showallglasses': 'Show all glasses',
  'Checkout': 'Checkout',
  'Total': 'Total',
  'Monthlysubscription': 'Monthly subscription',
  'Freescript': 'Try basic functions of system such as create your own Glasses model and download to tryon on GlassOn application',
  'Goldscript': 'Suitable for small and medium Eyewear Shop',
  'Enterprisescript': 'For big Eyewear Shop, Manufacture or someone who want to tailoring the system',
  'Register': 'Register ',
  'Glassesmodel': ' Glasses model',
  'Unlimited': 'Unlimited',
  'Glassesmode2': ' Glasses model',
  'Item1': 'Genarate Web link to GlassOn app',
  'Item2': 'Genarate QR code to GlassOn app',
  'Item3': 'Build Glasses model from 2D object',
  'Item4': 'Build Glasses model from 3D object',
  'Item5': 'Publish Glass model to Store list of GlassOn app',
  'Item6': 'Supply 2D/3D Glasses data <br /><span class="text-danger">(option: extra fee)</span>',
  'Item7': 'Tailoring GlassOn app on demand',
  'Item8': 'E-commerce solution with Tryon function builtin for Retail store',
  'Discount': 'Free trial 1 month, start charge fee in 2nd month',
  'Contractbase': 'Contract base',
  'PromotionPrice': 'Promotion Price',
  'Downloadsample': 'Example',

  // Thema
  'clipon': 'Clip-on',
  '3dacetate': '3D Acetate',
  'acetate': 'Acetate',
  'combined': 'Combined',
  'metal': 'Metal',
  'titanium': 'Titanium',
  'tr-90': 'TR-90',
  'ultem': 'Ultem',
  'black': 'Black',
  'blue': 'Blue',
  'brown': 'Brown',
  'cream': 'Cream',
  'gold': 'Gold',
  'gray': 'Gray',
  'green': 'Green',
  'orange': 'Orange',
  'pink': 'Pink',
  'red': 'Red',
  'violet': 'Violet',
  'white': 'White',
  'yellow': 'Yellow',
  'gunmetal': 'Gunmetal',
  'havana': 'Havana',
  'metal': 'Metal',
  'multicolor': 'Multi-color',
  'pattern': 'Pattern',
  
  'Store List': 'Store List',
  'Delegate List': 'Store List',
  'Owner': 'Owner',
  'Archive': 'Archive',
  'PD Measurement': 'PD Measurement',
  'Model type': 'Model type',
  'Add store': 'Add store',
  'Add store successfully': 'Add store successfully',
  'Owner product count': 'Owner product count',
  'Shared product count': 'Shared product count',
  'Product setting': 'Product setting',
  'Available SKUs': 'Available SKUs',
  'Owner SKUs': 'Owner SKUs',
  'Shared SKUs': 'Shared SKUs',
  'Owner setting': 'Owner setting',
  'Share with this store': 'Share with this store',
  'View bill list': 'View bill list',
  'Delete store': 'Delete store',
  'Are you sure to delete?': 'Are you sure to delete?',
  'Product Group': 'Product Group',
  'Group name': 'Group name',
  'Group not found': 'Group not found',
  'Add group': 'Add group',
  'Prioritize the model type you want to use': 'Prioritize the model type you want to use',
  'Use this iframe for glasses try-on': 'Use this iframe for glasses try-on',
  'Use this iframe for 360 degree glasses view': 'Use this iframe for 360 degree glasses view',
  'GO TESTING': 'GO TESTING',
  'Please fill in your store name': 'Please fill in your store name',
  'Password length must be at least 6 characters': 'Password length must be at least 6 characters',
  'Confirm password': 'Confirm password',
  'Confirm password not match': 'Confirm password not match',
  'Unarchive': 'Unarchive',
  'Business name': 'Business name',
  'Domain whitelist': 'Domain whitelist',
  'Domain whitelist (separated by comma)': 'Domain whitelist (separated by comma)',
  'Frame color': 'Frame color',
  'SKU: A-Z': 'SKU: A-Z',
  'SKU: Z-A': 'SKU: A-Z',
  'Usage count': 'Usage count',
  'Try-on builder': 'Try-On Builder',
  'PD Measurement Dashboard': 'PD Measurement Dashboard',
  'PD Measurement Integration Guideline': 'PD Measurement Integration Guideline',
  'Overview': 'Overview',
  'Domain Whitelist': 'Domain whitelist',
  'Integration Code': 'Integration code',
  'Demo (for reference only)': 'Demo (for reference only)',
  'Start free trial': 'Start free trial',
  'Get a quote': 'Get a quote',
}



// WEBPACK FOOTER //
// ./routes/app/intl/en.js